import { theme } from 'appCore';

export default {
  notFound: {
    display: 'flex',
    height: 500,
    fontSize: 40,
    color: theme.colors.primary,
    fontWeight: 'bold',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
